import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import { ArcHospiService } from "src/app/kiosk/services/arcHospi.service";
import { admissionDateIntervalError, admissionDateIntervalErrorFailure, admissionDateIntervalErrorSuccess, agreementSigned, agreementSignedFailure, agreementSignedSuccess, contractBlocked, contractBlockedFailure, contractBlockedSuccess, contractInvalid, contractInvalidFailure, contractInvalidSuccess, hospitalSelected, hospitalSelectedFailure, hospitalSelectedSuccess, identification, identificationFailure, identificationSuccess, medicalFormPrinted, medicalFormPrintedFailure, medicalFormPrintedSuccess, preHospiComplete, preHospiCompleteFailure, preHospiCompleteSuccess, preHospiOverwritten, preHospiOverwrittenFailure, preHospiOverwrittenSuccess, questionnaireSelected, questionnaireSelectedFailure, questionnaireSelectedSuccess, stopWithError, stopWithErrorFailure, stopWithErrorSuccess } from "./archospi.actions";

@Injectable()
export class ArchospiEffects {
	constructor(private actions$: Actions, private arcHospiService: ArcHospiService) { }

	public identification$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(identification),
			switchMap(({ cardNumber, insurerId, siteId, hospitalNo, language }) =>
				this.arcHospiService.identification(cardNumber, insurerId, siteId, hospitalNo, language).pipe(
					map((arcHospi) => identificationSuccess({ data: arcHospi })),
					catchError((err) => of(identificationFailure({ error: err })))
				)
			)
		);
	});
	public agreementSigned$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(agreementSigned),
			switchMap(() =>
				this.arcHospiService.agreementSigned().pipe(
					map((arcHospi) => agreementSignedSuccess({ data: arcHospi })),
					catchError((err) => of(agreementSignedFailure({ error: err })))
				)
			)
		);
	});

	public hospitalSelected$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(hospitalSelected),
			switchMap(({ siteId, hospitalNo }) =>
				this.arcHospiService.hospitalSelected(siteId, hospitalNo).pipe(
					map((arcHospi) => hospitalSelectedSuccess({ data: arcHospi })),
					catchError((err) => of(hospitalSelectedFailure({ error: err })))
				)
			)
		);
	});

	public questionnaireSelected$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(questionnaireSelected),
			switchMap(({ questionnaireId }) =>
				this.arcHospiService.questionnaireSelected(questionnaireId).pipe(
					map((arcHospi) => questionnaireSelectedSuccess({ data: arcHospi })),
					catchError((err) => of(questionnaireSelectedFailure({ error: err })))
				)
			)
		);
	});

	public preHospiCompleted$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(preHospiComplete),
			switchMap(({ hospitalizationId, lightColor, medicalFormRequired, medicalFormName,reasons }) =>
				this.arcHospiService.preHospiComplete(hospitalizationId, lightColor, medicalFormRequired, medicalFormName,reasons).pipe(
					map((arcHospi) => preHospiCompleteSuccess({ data: arcHospi })),
					catchError((err) => of(preHospiCompleteFailure({ error: err })))
				)
			)
		);
	});

	public preHospiOverwritten$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(preHospiOverwritten),
			switchMap(() =>
				this.arcHospiService.preHospiOverwritten().pipe(
					map((arcHospi) => preHospiOverwrittenSuccess({ data: arcHospi })),
					catchError((err) => of(preHospiOverwrittenFailure({ error: err })))
				)
			)
		);
	});

	public medicalFormPrinted$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(medicalFormPrinted),
			switchMap(() =>
				this.arcHospiService.medicalFormPrinted().pipe(
					map((arcHospi) => medicalFormPrintedSuccess({ data: arcHospi })),
					catchError((err) => of(medicalFormPrintedFailure({ error: err })))
				)
			)
		);
	});

	public admissionDateIntervalError$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(admissionDateIntervalError),
			switchMap(() =>
				this.arcHospiService.admissionPlannedDateIntervalError().pipe(
					map((arcHospi) => admissionDateIntervalErrorSuccess({ data: arcHospi })),
					catchError((err) => of(admissionDateIntervalErrorFailure({ error: err })))
				)
			)
		);
	});

	public contractBlocked$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(contractBlocked),
			switchMap(() =>
				this.arcHospiService.contractBlocked().pipe(
					map((arcHospi) => contractBlockedSuccess({ data: arcHospi })),
					catchError((err) => of(contractBlockedFailure({ error: err })))
				)
			)
		);
	});

	public contractInvalid$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(contractInvalid),
			switchMap(({kioskError}) =>
				this.arcHospiService.contractInvalid(kioskError).pipe(
					map((arcHospi) => contractInvalidSuccess({ data: arcHospi })),
					catchError((err) => of(contractInvalidFailure({ error: err })))
				)
			)
		);
	});

	public stopWithError$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(stopWithError),
			switchMap(({ kioskError }) => {
				return this.arcHospiService.stopWithError(kioskError).pipe(
					map((arcHospi) => stopWithErrorSuccess({ data: arcHospi })),
					catchError((err) => of(stopWithErrorFailure({ error: err })))
				)
			}
			)
		);
	});
}
